document.addEventListener("DOMContentLoaded", () => {
  const addToCartButtons = document.querySelectorAll(".nona-add-to-basket");
  const minusButtons = document.querySelectorAll(".nona-minus-button");
  const plusButtons = document.querySelectorAll(".nona-plus-button");

  plusButtons.forEach((pb) => {
    pb.addEventListener("click", () => {
      const amount = pb.parentElement.querySelector(".amount");
      amount.innerHTML = parseInt(amount.innerHTML) + 1;
    });
  });

  minusButtons.forEach((mb) => {
    mb.addEventListener("click", () => {
      const amount = mb.parentElement.querySelector(".amount");
      if (parseInt(amount.innerHTML) > 1) {
        amount.innerHTML = parseInt(amount.innerHTML) - 1;
      }
    });
  });
  addToCartButtons.forEach((button) => {
    button.addEventListener("click", async (e) => {
      button.disabled = true;
      const previousText = button.innerHTML;
      button.innerHTML = "Adding...";
      const variantid = button.dataset.variantid;
      const quantity = button.parentElement.querySelector(".amount").innerHTML;

      const x = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [{ id: variantid, quantity }],
          sections: "CartCount",
        }),
      });
      const data = await x.json();
      console.log("adata", data);
      const counterke = document.getElementById("nona-counter-cart");
      const currentCount = parseInt(counterke.innerHTML);
      counterke.innerHTML = currentCount + parseInt(quantity);
      counterke.parentElement.classList.remove("hide");

      // go to cart
      window.location.href = "/cart";
      setTimeout(() => {
        button.innerHTML = previousText;
        button.disabled = false;
      }, 2000);
    });
  });
});
